import { isEmpty } from 'lodash'
import localforage from 'localforage'

import Vuex from '@/store'
import { setToken as httpSetToken } from '@/plugins/http'

import { authTokenStorageKEY } from '@/config'
import { SET_TOKEN as TYPE_SET_TOKEN } from '@/app/auth/vuex/mutations-types'

export const load = () => {
  const token = Vuex.state.Auth.token

  if (!isEmpty(token)) {
    return Promise.resolve(token)
  }

  return localforage.getItem(authTokenStorageKEY)
    .then(token => {
      if (isEmpty(token)) {
        return Promise.reject(new Error('NO_AUTH_TOKEN')) // Reject promise
      }
      return token
    })
    .then(token => store(token))
}

export const store = (token) => {
  localforage.setItem(authTokenStorageKEY, token)
  Vuex.commit(TYPE_SET_TOKEN, token)
  httpSetToken(token)
  return token
}

export default { load, store }



// WEBPACK FOOTER //
// ./src/app/auth/services/token.js